import UserMenuItem from "./UserMenuItem";
import i18nPackage from "../../i18n/i18n";
import ListNumbersIcon from "./images/listNumbers.svg?react";
import SettingsIcon from "./images/settings.svg?react";
import SupportIcon from "./images/support.svg?react";

const ALL_PORTAL_MENU_ITEMS = ["setupGuide", "settings", "support"] as const;

export type PortalMenuItem = (typeof ALL_PORTAL_MENU_ITEMS)[number];

type PortalUserMenuItemsProps = {
	onMenuItemClick: (menuItem: PortalMenuItem) => void;
	visibleMenuItems?: readonly PortalMenuItem[];
};

export default function PortalUserMenuItems({
	onMenuItemClick,
	visibleMenuItems = ALL_PORTAL_MENU_ITEMS,
}: PortalUserMenuItemsProps) {
	const showMenu = (menuItem: PortalMenuItem) => visibleMenuItems.includes(menuItem);

	return (
		<>
			{showMenu("setupGuide") && (
				<UserMenuItem
					data-testid="guide-tab"
					onClick={() => {
						onMenuItemClick("setupGuide");
					}}
					Icon={ListNumbersIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.quickSetup")}
				</UserMenuItem>
			)}
			{showMenu("settings") && (
				<UserMenuItem
					data-testid="settings-tab"
					onClick={() => {
						onMenuItemClick("settings");
					}}
					Icon={SettingsIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.settings")}
				</UserMenuItem>
			)}
			{showMenu("support") && (
				<UserMenuItem
					data-testid="support-tab"
					onClick={() => {
						onMenuItemClick("support");
					}}
					Icon={SupportIcon}
				>
					{i18nPackage.t("coreComponents.userMenu.support")}
				</UserMenuItem>
			)}
		</>
	);
}
